module.exports = __webpack_public_path__ + "img/smoke-me-a-kipper-i-will-be-back-for-breakfast.101077fe.png";